export const successionSettingsSelector = state => state.successionSettings;
